import { SetFilterValuesFuncParams } from 'ag-grid-community';
import { Injectable } from '@angular/core';

@Injectable()
export class FilterParams {
  static qualityReviewStatusFilterOptions = [
    'No quality status',
    'Quality added',
    'Quality removed',
    'Quality approved',
  ];

  static readonly textFilterParams = {
    filterOptions: ['contains'],
    maxNumConditions: 1,
    buttons: ['clear', 'apply'],
    closeOnApply: true,
  };

  static readonly setFilterParams = {
    buttons: ['clear', 'apply'],
    suppressMiniFilter: true,
    closeOnApply: true,
  };

  static readonly dateFilterParams = {
    buttons: ['clear', 'apply'],
    suppressMiniFilter: true,
    closeOnApply: true,
    maxNumConditions: 1,
    filterOptions: ['equals', 'inRange', 'lessThan', 'greaterThan'],
  };

  static readonly goodsAndServicesFilterParams = {
    buttons: ['clear', 'apply'],
    suppressMiniFilter: true,
    closeOnApply: true,
    maxNumConditions: 2,
    numAlwaysVisibleConditions: 1,
    defaultJoinOperator: 'AND',
    filterOptions: ['Begins with', 'equals'],
  };
  static readonly threatNameFilterParams = {
    filterOptions: ['contains', 'Begins with', 'endsWith', 'equals'],
    buttons: ['clear', 'apply'],
    suppressMiniFilter: true,
    closeOnApply: true,
    maxNumConditions: 2,
    numAlwaysVisibleConditions: 1,
    defaultJoinOperator: 'AND',
  };

  static readonly qualityReviewStatusFilterParams = {
    defaultToNothingSelected: true,
    ...((FilterParams && FilterParams.setFilterParams) || {}),
    values: (params: SetFilterValuesFuncParams) => {
      params.success(FilterParams.qualityReviewStatusFilterOptions);
    },
  };
}
